import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/api";

export const Footer = () => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      const { data } = await api.post("/newsletter", { email });
      toast.success(data.message);
      setEmail("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <footer className="border-t border-[#27272A] bg-[#0A0A0A] mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <div className="bg-white px-4 py-2 inline-flex items-center mb-4">
            <img src="/logo.png" alt="UKJobLots — Big Brands. Clearance Prices." className="h-12 w-auto" />
          </div>
          <p className="text-white/50 text-sm leading-relaxed max-w-xs">
            Job lots, pallets and clearance stock. Direct from UK retailers and distributors. Members only.
          </p>
          <div className="flex flex-wrap gap-x-4 gap-y-2 mt-6 text-[11px] uppercase tracking-widest">
            <Link to="/legal/terms" className="text-white/40 hover:text-[#FFCC00]">Terms</Link>
            <Link to="/legal/privacy" className="text-white/40 hover:text-[#FFCC00]">Privacy</Link>
            <Link to="/legal/returns" className="text-white/40 hover:text-[#FFCC00]">Returns</Link>
            <Link to="/legal/grading" className="text-white/40 hover:text-[#FFCC00]">Grading</Link>
          </div>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-widest text-white/40 mb-4">Navigate</h4>
          <div className="flex flex-col gap-2 text-sm">
            <Link to="/deals" className="text-white/70 hover:text-[#FFCC00]">Today's Deals</Link>
            <Link to="/reverse-auction" className="text-white/70 hover:text-[#FFCC00]">Reverse Auction</Link>
            <Link to="/coming-soon" className="text-white/70 hover:text-[#FFCC00]">Coming Soon</Link>
            <Link to="/how-it-works" className="text-white/70 hover:text-[#FFCC00]">How It Works</Link>
            <Link to="/sell-to-us" className="text-white/70 hover:text-[#FFCC00]">Sell To Us</Link>
            <Link to="/join" className="text-white/70 hover:text-[#FFCC00]">Join The Club</Link>
          </div>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-widest text-white/40 mb-4">Deal drops. Straight to your inbox.</h4>
          <form onSubmit={subscribe} className="flex border border-[#27272A] focus-within:border-[#FFCC00]">
            <input
              data-testid="newsletter-email-input"
              type="email"
              required
              placeholder="your@email.co.uk"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="flex-1 bg-transparent px-4 py-3 text-sm outline-none placeholder:text-white/30"
            />
            <button data-testid="newsletter-submit-button" disabled={busy} className="btn-industrial px-5 text-sm shrink-0">
              {busy ? "..." : "SIGN UP"}
            </button>
          </form>
          <p className="text-white/30 text-[11px] mt-3">No spam. One email per hero deal. Unsubscribe anytime.</p>
        </div>
      </div>
      <div className="border-t border-[#27272A] py-6 text-center text-[11px] uppercase tracking-widest text-white/30">
        © {new Date().getFullYear()} UKJobLots.co.uk — All stock sold as graded. Demo build.
      </div>
    </footer>
  );
};
